window.applySlider = function (){
    let carousels = document.querySelectorAll(".main-product-container .product-image-container .Carousel");
    carousels.forEach(function (carousel) {
      let rawConfig = carousel.getAttribute('data-flickity-config') || '{}';
      let config;
      try {
        config = JSON.parse(rawConfig);
      } catch(e) {
        config = {};
        console.error('Invalid Flickity config:', e);
      }
      new Flickity(carousel, config);
    });
}

applySlider();
  